import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, take, tap } from 'rxjs/operators';

import { ContentDocumentLink } from '../../models/content-document-link.model';
import { Invoice } from '../../models/invoice.model';
import * as invoiceAttachmentsActions from '../actions/invoice-attachments.action';
import { LoadInvoices } from '../actions/invoices.action';
import {
  getAllInvoices,
  getInvoicesLoaded,
} from '../selectors/invoices.selector';

@Injectable()
export class InvoiceAttachmentEffects {
  private actions$ = inject(Actions);

  private store = inject(Store);

  loadInvoiceAttachments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(invoiceAttachmentsActions.LOAD_INVOICE_ATTACHMENTS),
      switchMap(() =>
        this.store.select(getInvoicesLoaded).pipe(
          tap((loaded) => {
            if (!loaded) {
              this.store.dispatch(new LoadInvoices());
            }
          }),
          filter((loaded) => loaded),
          take(1),
          switchMap(() => this.store.select(getAllInvoices).pipe(take(1))),
          map(
            (invoices) =>
              new invoiceAttachmentsActions.LoadInvoiceAttachmentsSuccess(
                invoices
                  .filter(
                    (inv): inv is Invoice & { file: ContentDocumentLink } =>
                      inv.file != null,
                  )
                  .map((inv) => inv.file),
              ),
          ),
          catchError((error) =>
            of(new invoiceAttachmentsActions.LoadInvoiceAttachmentsFail(error)),
          ),
        ),
      ),
    ),
  );
}
